import { Component, OnInit, ViewContainerRef, ComponentFactoryResolver, HostListener } from '@angular/core';
import { MainPortalService } from '../../../services/main-portal.service';
import { MediaFilterationContract } from 'projects/shared/models/MediaFilterationContract';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Globals } from 'projects/shared/models/Globals';
import { KeyedCollection } from 'projects/shared/models/KeyedCollection';

declare var parentId: any;
declare var isChild: any;
declare var extraMediaItems: any;
declare var $: any;

@Component({
	selector: 'app-media-gallery',
	templateUrl: './media-gallery.component.html',
	styleUrls: []
})
export class MediaGalleryComponent implements OnInit {
	public thumbnailsURL: KeyedCollection<SafeUrl>;
	@HostListener('window:resize', ['$event'])
	onResize(event) {
		event.target.innerWidth;
		this.setMyClasses();
	}
	selectedIndex: any;
	mediaItems2: any;
	isStory: any;
	mediaItems: any;
	mediaSocialItems: any;
	mediaStoryItems: any;

	inputMedia: MediaFilterationContract;
	inputSocial: MediaFilterationContract;
	inputStory: MediaFilterationContract;

	myClasses: string;
	static show: boolean = false;

	mediaSlice: number = 17;
	socialSlice: number = 17;
	storySlice: number = 11;

	social: string = Globals.InnerLocalizedResources.Social;
	stories: string = Globals.InnerLocalizedResources.Stories;
	media: string = Globals.InnerLocalizedResources.Media;
	showMore: string = Globals.InnerLocalizedResources.ShowMore;
	back: string = Globals.InnerLocalizedResources.Back;


	constructor(private data: MainPortalService, private sanitizer: DomSanitizer,
		private componentFactoryResolver: ComponentFactoryResolver, private viewContainerRef: ViewContainerRef) {
		this.inputMedia = new MediaFilterationContract(parentId, 1, 17, false, extraMediaItems, isChild == null || isChild == undefined ? false : isChild);
		this.inputSocial = new MediaFilterationContract(parentId, 1, 17, null, extraMediaItems, isChild == null || isChild == undefined ? false : isChild);
		this.inputStory = new MediaFilterationContract(parentId, 1, 11, true, extraMediaItems, isChild == null || isChild == undefined ? false : isChild);
		this.getMediaItems();
		console.log(this.mediaSlice);
		this.thumbnailsURL = new KeyedCollection<number>();
	}

	ngOnInit() { }

	getMediaItems() {

		this.data.getMediaGallery(this.inputMedia).subscribe(response => {
			this.mediaItems = response["Data"]["mediaItems"];
			this.mediaSocialItems=response["Data"]["mediaSocialItems"];
			this.mediaStoryItems=response["Data"]["mediaStoryItems"];
			this.setMyClasses();
			this.setVideoThumbnails();
		});
		// ////
		// get media section
		// this.data.getMediaItems(this.inputMedia).subscribe(
		// 	response => {
		// 		this.mediaItems = response,
		// 			// get soical section
		// 			this.data.getMediaItems(this.inputSocial).subscribe(
		// 				response => {
		// 					this.mediaSocialItems = response,
		// 						// get story section
		// 						this.data.getMediaItems(this.inputStory).subscribe(
		// 							response => {
		// 								this.mediaStoryItems = response,

		// 									//setClasses
		// 									this.setMyClasses();
		// 								this.setVideoThumbnails();
		// 							});
		// 				})
		// 	});
	}

	showSpecificItems(media, social, story) {
		////		
		if (media != 0) {
			this.isMobile() ? media = 3 : media = 17;
			this.myClasses = "mediaCenterContainer mediaOnly";
		}
		else if (social != 0) {
			this.isMobile() ? social = 3 : social = 17;
			this.myClasses = "mediaCenterContainer mediaOnly";
		}
		else if (story != 0) {
			this.isMobile() ? story = 3 : story = 11;
			this.myClasses = "mediaCenterContainer storiesOnly";
		}

		if (MediaGalleryComponent.show = !MediaGalleryComponent.show) {
			this.setSlice(media, social, story);
			$('.mediaCenterContainer .showAll .text').text(this.back);
			$('.mediaCenterContainer .showAll span:last-child').attr('class', 'icon-back');

		}
		else {
			this.setMyClasses();
			$('.mediaCenterContainer .showAll .text').text(this.showMore);
			$('.mediaCenterContainer .showAll span:last-child').attr('class', 'icon-next');
		}
	}

	setSlice(mediaSlice, socialSlice, storySlice) {
		this.mediaSlice = mediaSlice;
		this.socialSlice = socialSlice;
		this.storySlice = storySlice;

		if (this.mediaItems.Data.ListItems.length <= mediaSlice && !MediaGalleryComponent.show) {
			setTimeout(() => {
				$('.mediaCenterContainer .mediaHeaderBox .showAll .text').hide();
				$('.mediaCenterContainer .mediaHeaderBox .showAll span:last-child').hide();
			}, 150);
		}

		if (this.mediaSocialItems.Data.ListItems.length <= socialSlice && !MediaGalleryComponent.show) {
			setTimeout(() => {
				$('.mediaCenterContainer .socialHeaderBox .showAll .text').hide();
				$('.mediaCenterContainer .socialHeaderBox .showAll .icon-next').hide();
			}, 150);
		}

		if (this.mediaStoryItems.Data.ListItems.length <= storySlice && !MediaGalleryComponent.show) {
			setTimeout(() => {
				$('.mediaCenterContainer .storiesHeaderBox .showAll .text').hide();
				$('.mediaCenterContainer .storiesHeaderBox .showAll .icon-next').hide();
			}, 150);
		}
	}

	setMyClasses() {

		if(this.mediaItems && this.mediaSocialItems && this.mediaStoryItems){
			if (MediaGalleryComponent.show) {
				MediaGalleryComponent.show = false;
				this.showSpecificItems(this.mediaSlice, this.socialSlice, this.storySlice);
				return;
			}

			this.myClasses = "mediaCenterContainer ";


			if (this.mediaItems.Data.ListItems.length != 0 && this.mediaSocialItems.Data.ListItems.length != 0 && this.mediaStoryItems.Data.ListItems.length != 0) {
				this.myClasses += "all";
				this.isMobile() ? this.setSlice(2, 2, 2) : this.setSlice(5, 2, 5);
			}
			else if (this.mediaItems.Data.ListItems.length != 0 && this.mediaSocialItems.Data.ListItems.length != 0 && this.mediaStoryItems.Data.ListItems.length == 0) {
				this.myClasses += "social-media";
				this.isMobile() ? this.setSlice(2, 2, 0) : this.setSlice(8, 8, 0);
			}
			else if ((this.mediaItems.Data.ListItems.length != 0 || this.mediaSocialItems.Data.ListItems.length != 0) && this.mediaStoryItems.Data.ListItems.length == 0) {
				this.myClasses += "mediaOnly";
				if (this.mediaItems.Data.ListItems.length != 0)
					this.isMobile() ? this.setSlice(2, 0, 0) : this.setSlice(17, 0, 0);
				else
					this.isMobile() ? this.setSlice(0, 2, 0) : this.setSlice(0, 17, 0);
			}
			else if (this.mediaItems.Data.ListItems.length == 0 && this.mediaSocialItems.Data.ListItems.length == 0 && this.mediaStoryItems.Data.ListItems.length != 0) {
				this.myClasses += "storiesOnly";
				this.isMobile() ? this.setSlice(0, 0, 2) : this.setSlice(0, 0, 17);
			}
			else if (this.mediaItems.Data.ListItems.length != 0 && this.mediaSocialItems.Data.ListItems.length == 0 && this.mediaStoryItems.Data.ListItems.length != 0) {
				this.myClasses += "media-stories";
				this.isMobile() ? this.setSlice(2, 0, 2) : this.setSlice(8, 0, 5);
			}
			else if (this.mediaItems.Data.ListItems.length == 0 && this.mediaSocialItems.Data.ListItems.length == 0 && this.mediaStoryItems.Data.ListItems.length == 0) {
				this.setSlice(0, 0, 0);
			}
		}
	}

	isMobile() {
		if (window.innerWidth >= 480) {
			return false;
		}

		return /android|webos|iphone|ipad|ipod|blackberry|windows phone/i.test(window.navigator.userAgent);
	}

	setVideoThumbnails() {
		for (let item of this.mediaItems.Data.ListItems) {
			if (item.MediaType == 'videoYoutube') {
				this.thumbnailsURL.Add(
					item.Id,
					this.sanitizer.bypassSecurityTrustResourceUrl("http://i.ytimg.com/vi/" + item.ExternalLink.split('=')[1] + "/default.jpg")
				);
			}
		}
		for (let item of this.mediaStoryItems.Data.ListItems) {
			if (item.MediaType == 'videoYoutube') {
				this.thumbnailsURL.Add(
					item.Id,
					this.sanitizer.bypassSecurityTrustResourceUrl("http://i.ytimg.com/vi/" + item.ExternalLink.split('=')[1] + "/default.jpg")
				);
			}
		}

	}

    openDialog(selectedIndex: any, items: any, isStory = false) {
		this.mediaItems2 = items;
        this.isStory = isStory;
		this.selectedIndex = selectedIndex;
		$("#exampleModal").modal();
	}

	arrayOne(n: number): any[] {
		return Array(n);
	}

	setReflectedIndex($event){
		this.selectedIndex=$event;
	}
}
